import { request } from '../request';

export const channelApi = {
  listChannelTypes: () => request('/config/channels/types'),

  listChannels: () => request('/config/channels'),

  /**
   * 任务模式：获取各渠道自动发现的投递目标（用户 / 会话），用于定时任务「消息频道」下拉。
   * 与研究模式 /json/user-scheduler-task/notify-channels 作用一致，仅接口与字段不同。
   * @param {object} [params]
   * @param {string} [params.channel] 可选，渠道 key，仅取指定渠道
   * @param {'user'|'session'} [params.type] 可选，仅取用户或会话
   * @param {string} [params.keyword] 可选，按 id/name 模糊搜索
   * @param {number} [params.preview_size] 可选，限制每个渠道返回条数
   */
  getChannelTargets: (params = {}) => {
    const searchParams = new URLSearchParams();
    if (params.channel) searchParams.append('channel', params.channel);
    if (params.type) searchParams.append('type', params.type);
    if (params.keyword) searchParams.append('keyword', params.keyword);
    if (params.preview_size !== undefined && params.preview_size !== null) {
      searchParams.append('preview_size', String(params.preview_size));
    }
    const query = searchParams.toString();
    return request(`/config/channels/targets${query ? `?${query}` : ''}`);
  },

  updateChannels: (body) =>
    request('/config/channels', {
      method: 'PUT',
      body: JSON.stringify(body)
    }),

  getChannelConfig: (channelName) => request(`/config/channels/${encodeURIComponent(channelName)}`),

  updateChannelConfig: (channelName, body) =>
    request(`/config/channels/${encodeURIComponent(channelName)}`, {
      method: 'PUT',
      body: JSON.stringify(body)
    }),

  getChannelQrcode: (channel) => request(`/config/channels/${encodeURIComponent(channel)}/qrcode`),

  getChannelQrcodeStatus: (channel, token) =>
    request(`/config/channels/${encodeURIComponent(channel)}/qrcode/status?token=${encodeURIComponent(token)}`),

  startWechatQrLogin: (body = {}) =>
    request('/wechat/login/qr/start', {
      method: 'POST',
      body: JSON.stringify(body)
    }),

  waitWechatQrLogin: (body) =>
    request('/wechat/login/qr/wait', {
      method: 'POST',
      body: JSON.stringify(body)
    })
};
